import React from 'react';
import { Link } from 'react-router-dom';
import { CLINIC } from '../mock';

// Official brand mark supplied by the clinic.
export const LogoMark = ({ size = 46, className = '' }) => (
  <img
    src="/favicon.png"
    alt="The Mood & Sleep Clinic logo"
    width={size}
    height={size}
    className={`object-contain ${className}`}
    style={{ width: size, height: size }}
  />
);

const Logo = () => (
  <Link to="/" className="flex items-center gap-3 group">
    <LogoMark size={48} />
    <div className="leading-tight">
      <div className="font-heading font-semibold tracking-[0.18em] text-navy text-[13px] sm:text-[15px] uppercase">
        The Mood &amp; Sleep Clinic
      </div>
      <div className="font-heading tracking-[0.3em] text-[8px] sm:text-[9px] text-[#4a86f7] uppercase">
        {CLINIC.tagline}
      </div>
    </div>
  </Link>
);

export default Logo;
